import Icon from './Icon';
import { STATS, WHY_POINTS } from '../constants/content';
import { SITE_NAME } from '../constants/site';

export default function WhyChoose() {
  return (
    <section className="section section--mint" id="why">
      <div className="shell">
        <header className="section__head">
          <p className="kicker">Why us</p>
          <h2>Why businesses trust {SITE_NAME}</h2>
          <p className="section__lede">
            Clean, accurate books decide what you can pay, borrow and file. We treat
            every file like it is our own.
          </p>
        </header>

        <div className="why why--flip">
          <ul className="why__list">
            {WHY_POINTS.map((point) => (
              <li key={point.title}>
                <span className="why__icon">
                  <Icon name={point.icon} size={20} />
                </span>
                <div>
                  <h3>{point.title}</h3>
                  <p>{point.body}</p>
                </div>
              </li>
            ))}
          </ul>

          <figure className="why__visual">
            <img
              src="/images/why-office.webp"
              alt="Accountants working at computers in a bright office"
              width="1100"
              height="825"
              loading="lazy"
              decoding="async"
            />
            <figcaption className="why__badge">
              <Icon name="badge" size={20} />
              Certified experts — 24/7
            </figcaption>
          </figure>
        </div>

        <div className="stats stats--bar">
          {STATS.map((stat) => (
            <div className="stat" key={stat.label}>
              <strong>{stat.value}</strong>
              <span>{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
